export default "__VITE_ASSET__Cikvkig6__"